module.exports = __webpack_public_path__ + "img/TFT-en.690ff0b2.jpg";